import { render, staticRenderFns } from "./RoomClosedChatMessage.htm?vue&type=template&id=07116b90&scoped=true&"
import script from "./RoomClosedChatMessage.ts?vue&type=script&lang=js&"
export * from "./RoomClosedChatMessage.ts?vue&type=script&lang=js&"
import style0 from "./RoomClosedChatMessage.scss?vue&type=style&index=0&id=07116b90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07116b90",
  null
  
)

export default component.exports